import { createTheme } from '@mantine/core';

export const shadows = createTheme({
  shadows: {
    medium: '0px 5px 15px 0px rgba(0, 0, 0, 0.05)',
    dark: '0px 4px 15px 0px #161D2526',
  },
});
